import React from 'react';
import { Star, Gift, Gamepad2, Shield, TrendingUp, Award, AlertCircle } from 'lucide-react';
import FAQSection from '../components/FAQSection';
import SEOHelmet from '../components/SEOHelmet';
import CollapsibleSEO from '../components/CollapsibleSEO';
import './Homepage.css';

const Homepage = () => {
  const advantages = [
    { icon: <Star />, title: 'Über 5.000 Spiele', description: 'Riesige Auswahl an Slots, Tischspielen und Live-Casino' },
    { icon: <Gift />, title: 'Großzügige Boni', description: 'Willkommensbonus bis zu 5.000€ + 200 Freispiele' },
    { icon: <Shield />, title: 'Sicher & Lizenziert', description: 'Vollständig lizenziert und reguliert' },
    { icon: <TrendingUp />, title: 'Schnelle Auszahlungen', description: 'Blitzschnelle Auszahlungen innerhalb von 24 Stunden' },
    { icon: <Award />, title: 'VIP-Programm', description: 'Exklusive Belohnungen für treue Spieler' },
    { icon: <Gamepad2 />, title: 'Mobile Gaming', description: 'Spielen Sie überall auf Ihrem Smartphone' }
  ];

  const popularSlots = [
    { 
      name: 'Gates of N1 1000', 
      provider: 'N1 Casino',
      image: 'https://customer-assets.emergentagent.com/job_glucksspiel-n1/artifacts/bd73q0q4_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-11%20%D0%B2%2023.50.12.png'
    },
    { 
      name: 'Book of the Fallen', 
      provider: 'N1 Casino',
      image: 'https://customer-assets.emergentagent.com/job_glucksspiel-n1/artifacts/59lg0pr5_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-11%20%D0%B2%2023.50.00.png'
    },
    { 
      name: 'Big Bass Splash', 
      provider: 'Pragmatic Play',
      image: 'https://customer-assets.emergentagent.com/job_glucksspiel-n1/artifacts/ewnd02u4_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-11%20%D0%B2%2023.50.40.png'
    },
    { 
      name: 'N1 Million', 
      provider: 'N1 Casino',
      image: 'https://customer-assets.emergentagent.com/job_glucksspiel-n1/artifacts/jb2f9t3d_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-11%20%D0%B2%2023.51.22.png'
    },
    { 
      name: 'Gates of Olympus Super Scatter', 
      provider: 'Pragmatic Play',
      image: 'https://customer-assets.emergentagent.com/job_glucksspiel-n1/artifacts/pbf66l0f_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-11%20%D0%B2%2023.51.02.png'
    }
  ];

  const gameCategories = [
    { title: 'Slots', count: '3.000+', description: 'Die neuesten und beliebtesten Spielautomaten' },
    { title: 'Live Casino', count: '200+', description: 'Echte Dealer, echte Gewinne in Echtzeit' },
    { title: 'Tischspiele', count: '150+', description: 'Roulette, Blackjack, Baccarat und mehr' },
    { title: 'Jackpot-Spiele', count: '50+', description: 'Mega-Jackpots mit Millionen-Gewinnen' }
  ];

  const faqData = [
    {
      question: 'Ist N1 Casino sicher und lizenziert?',
      answer: 'Ja, N1 Casino ist vollständig lizenziert und reguliert. Wir verwenden modernste SSL-Verschlüsselungstechnologie, um Ihre persönlichen Daten und Transaktionen zu schützen. Alle Spiele werden regelmäßig von unabhängigen Prüfstellen auf Fairness getestet.'
    },
    {
      question: 'Wie funktioniert der Willkommensbonus bei N1 Casino?',
      answer: 'Neue Spieler bei N1 Casino erhalten einen großzügigen Willkommensbonus von bis zu 5.000€ plus 200 Freispiele. Der Bonus wird auf Ihre ersten Einzahlungen verteilt. Bitte beachten Sie die Bonusbedingungen und Umsatzanforderungen in unseren AGB.'
    },
    {
      question: 'Welche Zahlungsmethoden werden bei N1 Casino akzeptiert?',
      answer: 'N1 Casino akzeptiert eine Vielzahl von Zahlungsmethoden, darunter Kreditkarten (Visa, Mastercard), E-Wallets (Skrill, Neteller), Banktransfers und Prepaid-Karten. Auszahlungen werden in der Regel innerhalb von 24 Stunden bearbeitet.'
    },
    {
      question: 'Kann ich N1 Casino auf meinem Smartphone spielen?',
      answer: 'Ja, N1 Casino ist vollständig mobiloptimiert. Sie können alle Ihre Lieblingsspiele direkt über Ihren mobilen Browser spielen, ohne eine App herunterladen zu müssen. Die mobile Version bietet das gleiche erstklassige Spielerlebnis wie die Desktop-Version.'
    },
    {
      question: 'Wie lange dauern Auszahlungen bei N1 Casino?',
      answer: 'Auszahlungen bei N1 Casino werden in der Regel innerhalb von 24 Stunden bearbeitet. Die tatsächliche Zeit bis zum Eingang auf Ihrem Konto hängt von der gewählten Zahlungsmethode ab. E-Wallets sind in der Regel am schnellsten, während Banktransfers 3-5 Werktage dauern können.'
    },
    {
      question: 'Gibt es ein VIP-Programm bei N1 Casino?',
      answer: 'Ja, N1 Casino bietet ein exklusives VIP-Programm für treue Spieler. Als VIP-Mitglied erhalten Sie Zugang zu besonderen Boni, schnelleren Auszahlungen, einem persönlichen Account Manager und exklusiven Veranstaltungen. Je mehr Sie spielen, desto höher steigen Sie im VIP-Level auf.'
    }
  ];

  // Schema.org markup for Homepage (after faqData is defined)
  const schemaOrgWebsite = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "N1 Casino",
    "url": "https://n1casino-review.com",
    "logo": "https://eu2007.de/?attachment_id=18472",
    "description": "N1 Casino - Deutschlands Premier Online Casino mit über 5.000 Spielen",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "9.5",
      "bestRating": "10",
      "ratingCount": "5000"
    }
  };

  const schemaOrgFAQ = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  const schemaOrgReview = {
    "@context": "https://schema.org",
    "@type": "Review",
    "itemReviewed": {
      "@type": "LocalBusiness",
      "name": "N1 Casino"
    },
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "9.5",
      "bestRating": "10"
    },
    "author": {
      "@type": "Organization",
      "name": "Casino Review Team"
    }
  };

  return (
    <div className="homepage">
      <SEOHelmet 
        title="N1 Casino Bewertung 2025 - N1 Casino Deutschland | N1 Bet Casino Erfahrungen"
        description="N1 Casino Review 2025 ⭐ Über 5.000 Spiele ✓ Willkommensbonus 5.000€ + 200 FS ✓ Schnelle Auszahlungen ✓ N1 Bet Casino ✓ N1Casino Login ✓ Offizielle N1 Casino Bewertung"
        keywords="n1 bet, n1 casino, n1bet, n1casino"
        canonical="https://n1casino-review.com/"
        schema={[schemaOrgWebsite, schemaOrgFAQ, schemaOrgReview]}
      />
      {/* Hero Section with Banner */}
      <section className="hero-section hero-banner">
        <div className="hero-banner-image">
          <img 
            src="https://customer-assets.emergentagent.com/job_glucksspiel-n1/artifacts/sau9xqbg_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-11%20%D0%B2%2022.40.55.png"
            alt="N1 Casino Banner"
          />
        </div>
        <div className="hero-container">
          <div className="hero-content">
            <div className="rating-badge">
              <Star fill="#DC0000" color="#DC0000" size={20} />
              <Star fill="#DC0000" color="#DC0000" size={20} />
              <Star fill="#DC0000" color="#DC0000" size={20} />
              <Star fill="#DC0000" color="#DC0000" size={20} />
              <Star fill="#DC0000" color="#DC0000" size={20} />
              <span className="rating-text">9.5/10 Bewertung</span>
            </div>
            <h1 className="hero-title">
              Willkommen bei N1 Casino – <br />
              Deutschlands Premier Online Casino
            </h1>
            <p className="hero-subtitle">
              Erleben Sie über 5.000 erstklassige Casinospiele mit großzügigen Boni,
              schnellen Auszahlungen und einem unvergleichlichen Spielerlebnis.
            </p>
            <div className="hero-cta">
              <button className="btn-primary">Jetzt spielen</button>
              <div className="bonus-highlight">
                <Gift size={24} color="#DC0000" />
                <div>
                  <strong>Willkommensbonus 5.000€ + 200 FS</strong>
                  <p>& Puzzle Flip!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="advantages-section section">
        <div className="container">
          <h2 className="section-title">Warum N1 Casino wählen?</h2>
          <p className="section-subtitle">
            Entdecken Sie die vielen Vorteile, die N1 Casino zur ersten Wahl für deutsche Spieler machen
          </p>
          <div className="advantages-grid">
            {advantages.map((advantage, index) => (
              <div key={index} className="advantage-card">
                <div className="advantage-icon">{advantage.icon}</div>
                <h3>{advantage.title}</h3>
                <p>{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bonus Section */}
      <section className="bonus-section section">
        <div className="container">
          <div className="bonus-card bonus-with-image">
            <div className="bonus-image-container">
              <img 
                src="https://customer-assets.emergentagent.com/job_glucksspiel-n1/artifacts/6vek9d9v_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-11%20%D0%B2%2022.51.21.png"
                alt="N1 Casino Willkommensbonus"
                className="bonus-feature-image"
              />
            </div>
            <div className="bonus-content">
              <h2>Willkommensbonus 5.000€ + 200 FS & Puzzle Flip!</h2>
              <p>
                Starten Sie Ihre N1 Casino-Reise mit einem spektakulären Willkommensbonus! 
                Erhalten Sie bis zu 5.000€ Bonusgeld plus 200 Freispiele auf Ihre ersten Einzahlungen.
              </p>
              <ul className="bonus-features">
                <li>100% bis zu 500€ auf die erste Einzahlung + 200 Freispiele</li>
                <li>50% bis zu 1.500€ auf die zweite Einzahlung</li>
                <li>25% bis zu 3.000€ auf die dritte Einzahlung</li>
                <li>Puzzle Flip-Feature für zusätzliche Belohnungen</li>
              </ul>
              <button className="btn-primary">Jetzt Bonus sichern</button>
              <p className="bonus-terms">18+ | AGB gelten | Verantwortungsbewusst spielen</p>
            </div>
          </div>
        </div>
      </section>

      {/* Game Categories Section */}
      <section className="games-section section">
        <div className="container">
          <h2 className="section-title">Über 5.000 Spiele bei N1 Casino</h2>
          <p className="section-subtitle">
            Entdecken Sie eine riesige Auswahl an Spielen von führenden Anbietern
          </p>
          <div className="game-categories-grid">
            {gameCategories.map((category, index) => (
              <div key={index} className="category-card">
                <h3>{category.title}</h3>
                <div className="category-count">{category.count}</div>
                <p>{category.description}</p>
              </div>
            ))}
          </div>

          <div className="popular-slots">
            <h3>Beliebte Slots bei N1 Casino:</h3>
            <div className="slots-grid">
              {popularSlots.map((slot, index) => (
                <div key={index} className="slot-card">
                  <div className="slot-image-container">
                    <img src={slot.image} alt={slot.name} className="slot-image" />
                  </div>
                  <h4>{slot.name}</h4>
                  <p>{slot.provider}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SEO Content Section - Collapsible */}
      <section className="seo-content-section">
        <div className="container">
          <CollapsibleSEO
            title="N1 Casino: Ihr vertrauenswürdiger Partner für erstklassiges Online-Gaming"
            firstParagraph={
              <p>
                N1 Casino hat sich seit seiner Gründung als eines der führenden Online-Casinos in Deutschland etabliert. 
                Mit einer beeindruckenden Auswahl von über 5.000 Spielen von renommierten Anbietern wie NetEnt, Microgaming, 
                Play'n GO und Pragmatic Play bietet N1 Casino eine unvergleichliche Spielvielfalt. Ob Sie ein Fan von klassischen 
                Spielautomaten, modernen Video-Slots, Tischspielen oder Live-Casino-Action sind – bei N1 Casino finden Sie 
                garantiert das perfekte Spiel für Ihren Geschmack.
              </p>
            }
          >
            <div className="content-grid">
              <div className="content-block">
                <p>
                  Die Plattform zeichnet sich durch ihre benutzerfreundliche Oberfläche, schnelle Ladezeiten und nahtlose Navigation aus. 
                  N1 Casino ist vollständig mobiloptimiert, sodass Sie Ihre Lieblingsspiele jederzeit und überall genießen können. 
                  Die Sicherheit und der Datenschutz der Spieler haben bei N1 Casino höchste Priorität, weshalb modernste 
                  SSL-Verschlüsselungstechnologie zum Einsatz kommt.
                </p>
              </div>

            <div className="content-block">
              <h3>Großzügige Boni und Promotionen bei N1 Casino</h3>
              <p>
                N1 Casino begrüßt neue Spieler mit einem spektakulären Willkommensbonus von bis zu 5.000€ plus 200 Freispiele. 
                Dieser großzügige Bonus wird auf Ihre ersten Einzahlungen verteilt und gibt Ihnen die Möglichkeit, das Casino 
                ausgiebig zu erkunden. Zusätzlich zum Willkommensbonus bietet N1 Casino regelmäßige Promotionen, Reload-Boni, 
                Cashback-Angebote und spezielle Turniere mit attraktiven Preisen.
              </p>
              <p>
                Das innovative Puzzle Flip-Feature ist eine weitere Besonderheit von N1 Casino. Bei jeder Einzahlung erhalten Sie 
                Puzzleteile, die Sie sammeln und gegen zusätzliche Belohnungen eintauschen können. Das VIP-Programm belohnt treue 
                Spieler mit exklusiven Vorteilen wie persönlichen Account Managern, schnelleren Auszahlungen, höheren 
                Auszahlungslimits und Einladungen zu besonderen Events.
              </p>
            </div>

            <div className="content-block">
              <h3>Vielfältige Spielauswahl bei N1 Casino</h3>
              <p>
                Die Spielbibliothek von N1 Casino ist wirklich beeindruckend. Mit über 3.000 Slots finden Sie hier alles von 
                klassischen Früchte-Slots bis hin zu modernen Video-Slots mit innovativen Features, Megaways-Mechaniken und 
                progressiven Jackpots. Beliebte Titel wie Book of Dead, Starburst, Gonzo's Quest, Reactoonz und Sweet Bonanza 
                sind nur einige der Highlights im Slot-Angebot.
              </p>
              <p>
                Für Fans von Tischspielen bietet N1 Casino eine umfangreiche Auswahl an Roulette, Blackjack, Baccarat und Poker-Varianten. 
                Das Live-Casino ist besonders beeindruckend mit über 200 Live-Tischen, die von professionellen Dealern geleitet werden. 
                Hier können Sie die Atmosphäre eines echten Casinos in Echtzeit erleben, direkt von Ihrem Wohnzimmer aus.
              </p>
            </div>

            <div className="content-block">
              <h3>Schnelle und sichere Zahlungen bei N1 Casino</h3>
              <p>
                N1 Casino bietet eine breite Palette an sicheren und zuverlässigen Zahlungsmethoden. Spieler können zwischen 
                Kreditkarten (Visa, Mastercard), E-Wallets (Skrill, Neteller, ecoPayz), Banktransfers und Prepaid-Karten wählen. 
                Einzahlungen werden sofort verarbeitet, sodass Sie ohne Verzögerung mit dem Spielen beginnen können.
              </p>
              <p>
                Ein besonderer Vorteil von N1 Casino sind die schnellen Auszahlungen. Die meisten Auszahlungsanfragen werden 
                innerhalb von 24 Stunden bearbeitet, und bei E-Wallets können Sie Ihr Geld oft noch schneller erhalten. 
                N1 Casino erhebt keine Gebühren für Ein- oder Auszahlungen, was die Plattform noch attraktiver macht.
              </p>
            </div>

            <div className="content-block">
              <h3>Kundenservice und verantwortungsvolles Spielen</h3>
              <p>
                Der Kundenservice von N1 Casino ist rund um die Uhr per Live-Chat und E-Mail erreichbar. Das kompetente und 
                freundliche Support-Team beantwortet alle Fragen schnell und professionell auf Deutsch. Zusätzlich bietet die 
                umfangreiche FAQ-Sektion Antworten auf die häufigsten Fragen.
              </p>
              <p>
                N1 Casino nimmt das Thema verantwortungsvolles Spielen sehr ernst. Die Plattform bietet verschiedene Tools zur 
                Selbstkontrolle, darunter Einzahlungslimits, Verlustlimits, Sitzungslimits und Selbstausschlussoptionen. 
                Spieler unter 18 Jahren sind vom Spielen ausgeschlossen, und N1 Casino arbeitet mit Organisationen wie 
                GamCare und BeGambleAware zusammen, um problematisches Spielverhalten zu verhindern.
              </p>
            </div>
          </div>
          </CollapsibleSEO>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section section">
        <div className="container">
          <h2 className="section-title">Häufig gestellte Fragen zu N1 Casino</h2>
          <FAQSection faqs={faqData} />
        </div>
      </section>
    </div>
  );
};

export default Homepage;
